const buildDate = '2026-10-13T17:09:55+0000'
export default buildDate